import { createSelector } from 'reselect'
import adminOnboardingOfferTitleSelector from 'redux/selectors/admin_onboarding/admin_onboarding_offer_title_selector'

const getAdminOnboardingData = state => state.adminOnboarding

const adminOnboardingAddTeachers = createSelector(
	[getAdminOnboardingData, adminOnboardingOfferTitleSelector],
	(adminOnboarding, offerTitleSelector) => ({
		usersCount: adminOnboarding.users.length - 1,
		offerTitle: offerTitleSelector.offerTitle,
	})
)

export default adminOnboardingAddTeachers
